// Contacts Page

import "./contactspage.css";
import Email from './emailform/email';

export default function ContactsPage() {
    return (
        <div className="contacts-page">
            {/* Contact Details */}
            <img 
                src="/images/connectwithme.webp" 
                alt="Connect with Me" 
                className="contact-image"
                loading="eager"
            />
            <div className="contacts-row">
                {/* Left column */}
                <ul className="contacts">
                    <li>
                        <a href="https://github.com/ejeankuo" className="contact-link"> 
                            <img src="/images/github-logo.png" alt="github" className="logo"/> 
                            github.com/ejeankuo
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/in/ejeankuo/" className="contact-link"> 
                            <img src="/images/linkedin-logo.png" alt="linkedin" className="logo"/> 
                            linkedin.com/in/ejeankuo
                        </a>
                    </li> 
                </ul>

                {/* Right column */}
                <div className="email-form">
                    <Email />
                </div>
            </div>
        </div>
    );
  }

/* <li>
        <a href="mailto:ejean.swe@gmail.com" className="contact-link"> 
            <img src="/mail-logo.png" alt="mail" className="logo"/> 
            ejean.swe@gmail.com
        </a>
    </li>
*/